import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPending = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7641_193606)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M3.35156 11.7778C3.35156 7.35957 6.93328 3.77734 11.3516 3.77734C15.7698 3.77734 19.3516 7.35957 19.3516 11.7778C19.3516 16.1961 15.7698 19.7783 11.3516 19.7783C6.93328 19.7783 3.35156 16.1961 3.35156 11.7778Z",
			fill: "#FF622C"
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 11.3516,
			cy: 11.7773,
			r: 4,
			fill: "white"
		})]
	})
});
const ForwardRef = forwardRef(SvgPending);
export default ForwardRef;
